import React, { useEffect, useState } from 'react';
import { Col, Row, Table } from 'antd';
import { getCitas } from 'api/tramites/citas';
import { toMoment, getDistinctValues } from 'utils/normalizers';
import { DATE_FORMAT } from 'utils/formatValues';
import { getPlantillaNoIndexada } from 'api/tramites';
import { EyeOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router';
import { Button } from 'components';
import styled from 'styled-components';

const estatusCitasMap = {
  1: 'Programada',
  2: 'En proceso',
  3: 'No asistió',
  4: 'Finalizada',
  5: 'Cancelada',
};

const MisCitas = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({ results: [], page: 1 });
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const fetchData = async (page = 1) => {
    setLoading(true);
    const _data = await getCitas({ page });
    _data.page = page;
    const plantillas = await Promise.all(
      getDistinctValues(_data.results.map((c) => c.plantilla_de_tramite))
        .map((p) => getPlantillaNoIndexada(p)),
    );
    _data.results = _data.results.map((c) => ({
      ...c,
      nombre_tramite: plantillas.find((p) => p.id === c.plantilla_de_tramite)?.nombre,
    }));
    setData(_data);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const columns = [
    {
      title: 'Folio',
      key: 'folio',
      dataIndex: 'folio',
      width: 150,
    },
    {
      title: 'Trámite',
      key: 'nombre_tramite',
      dataIndex: 'nombre_tramite',
      width: 400,
    },
    {
      title: 'Nombre',
      key: 'nombre_completo',
      dataIndex: 'nombre_completo',
      width: 300,
    },
    {
      title: 'Fecha y hora',
      key: 'horario_inicio',
      dataIndex: 'horario_inicio',
      width: 190,
      render: (_, c) => toMoment(`${c.fecha_cita} ${c.horario_inicio}`, [`${DATE_FORMAT} hh:mm:ss`]).format('L hh:mm A'),
    },
    {
      title: 'Estado',
      key: 'estado_de_cita',
      dataIndex: 'estado_de_cita',
      width: 110,
      render: (val) => estatusCitasMap[val],
    },
  ];

  const onClick = () => navigate('/citas/consulta', { state: { cita: selectedRowKeys[0] } });

  return (
    <Container span={24}>
      <Row justify="end">
        <Button disabled={!selectedRowKeys.length} type="link" onClick={onClick}>
          <EyeOutlined />
          Ver detalle
        </Button>
      </Row>
      <Table
        columns={columns}
        dataSource={data.results}
        rowSelection={{ selectedRowKeys, type: 'radio' }}
        onRow={(record) => ({
          onClick: () => {
            setSelectedRowKeys([record.folio]);
          },
        })}
        rowClassName={({ estado_de_cita }) => `estatus-${estado_de_cita}`}
        pagination={{
          total: data.count,
          onChange: fetchData,
          showSizeChanger: false,
          current: data.page,
        }}
        rowKey="folio"
        size="small"
        loading={loading}
        scroll={{ x: columns.reduce((acum, curr) => acum + curr.width, 0) }}
      />
    </Container>
  );
};

const Container = styled(Col)`
  .estatus-1, .estatus-2, .estatus-3, .estatus-4, .estatus-5 {
    color: #000000 !important;
    font-weight: bold;
  }
  .estatus-1 td {
    background-color: #7cbf79 !important;
  }
  .estatus-3 td {
    background-color: #fff3cd !important;
  }
  .estatus-4 td {
    background-color: #9fcdfa !important;
  }
  .estatus-5 td {
    background-color: #fababf !important;
  }
`;

export default MisCitas;
